import {useEffect} from 'react';
import {usePostHog} from '@posthog/react';

import {getFullName, useAuthStore} from 'core/stores/auth';
import {useFeatureFlag, useUserInfo} from 'core/hooks/authHooks';
import {impersonationToken} from 'core/impersonation';
import {FeatureFlags} from 'core/constants/featureFlags';

const POST_HOG_SOURCE = 'Decisions';

export const useInitializePostHog = () => {
  const posthog = usePostHog();
  const {id, profile: {email} = {}, tenantId, tenantName, roleType} = useUserInfo();
  const fullName = useAuthStore(getFullName);
  const withPostHog = useFeatureFlag(FeatureFlags.PostHog);

  useEffect(() => {
    if (!withPostHog) {
      posthog.opt_out_capturing();
      return;
    }

    if (!email || !id) return;

    posthog.opt_in_capturing();
    posthog.identify(id, {
      email,
      name: fullName,
      tenantId,
      tenantName,
      roleType,
      isInternal: email.endsWith('@ennabl.com'),
    });
    posthog.register({
      impersonated: Boolean(impersonationToken),
      source: POST_HOG_SOURCE,
      tenantId,
      tenantName,
      roleType,
    });
  }, [id, email, fullName, tenantId, tenantName, roleType, withPostHog, posthog]);
};
